import React, { useEffect, useState } from "react";
import Block from "../../../components/block/block";
import {
  Backdrop,
  Box,
  CircularProgress,
  Typography,
  Button,
} from "@mui/material";
import { useSelector } from "react-redux";
import { cfpBaseUrl } from "../../../network/urls";
import {
  allCompaniesAPI,
  getName,
  convertDatewithTime,
} from "../../../services/Functions";
import jsPDF from "jspdf";
import "jspdf-autotable";
import pdf from "../../../images/pdf.png";
import { internalIconStyles } from "../../../style/common";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../../images/pitc.png";
import "../../../style/common.scss";
import eOpsLogo from "../../../images/eops.png";
const LoggedInUsers = () => {
  const [usersArray, setUsersArray] = useState([]);
  const [offlineUsers, setOfflineUsers] = useState(0);
  const [onlineUsers, setOnlineUsers] = useState(0);
  const [inactiveUsers, setInactiveUsers] = useState(0);
  const [companyList, setCompanyList] = useState([]);
  const [desginationList, setDesginationList] = useState([]);
  const [filteredDesignationList, setFilteredDesignationList] = useState([]);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const [circleCode, setCircleCode] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [desginationName, setDesginationName] = useState("TAC");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [circleName, setCircleName] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [desginationCodeToApi, setDesginationCodeToApi] = useState("1135");
  const [officeCode, setOfficeCode] = useState("");
  const [noDataFound, setNoDataFound] = useState(false);
  const [shiftWise, setShiftWise] = useState("1");
  const [sourceWise, setSourceWise] = useState("2");
  const [complaintPart, setComplaintPart] = useState("2"); // Default to Technical
  const [isDesignation1135, setIsDesignation1135] = useState(false); // Controls UI rendering
  const [officeName, setOfficeName] = useState("");
  const [hierarchy, setHierarchy] = useState("");
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const {
    code,
    token,
    roleTypeName,
    cscID,
    cfcLevelId,
    roleName,
    name,
    hierarchy: hierar,
  } = useSelector((state) => state.auth);
  const companyCode = code.slice(0, 2);
  const offCode =
    hierar == 1
      ? code
      : hierar == 2
      ? code.slice(0, 2)
      : hierar == 3
      ? code.slice(0, 3)
      : hierar == 4
      ? code.slice(0, 4)
      : hierar == 5
      ? code.slice(0, 5)
      : code;
  const OffLevel = String(officeCode).length;
  function getCurrentDateFormatted(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const options = { month: "short" };
    const month = date.toLocaleString("en-US", options);
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  }
  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };

  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
      default:
        return "";
    }
  };

  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = officeName;
      let dateToPrint = getCurrentDateFormatted(new Date());
      // Initialize PDF
      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);
      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );
      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);
      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(`Logged In users`, pageWidth / 2, 18, { align: "center" });
      pdf.setFontSize(10);
      pdf.text(
        `Logged In users ${desginationName} for ${offName} of ${dateToPrint}`,
        pageWidth / 2,
        25,
        { align: "center" }
      );
      let yPosition = 30;
      // Add legend circles at the top
      yPosition += 10; // Space after legend
      // Handle no data
      if (noDataFound) {
        pdf.setFontSize(16);
        pdf.setTextColor(255, 0, 0);
        pdf.text("No Data Found.", pageWidth / 2, yPosition, {
          align: "center",
        });
        yPosition += 20;
      } else if (isDesignation1135 && groupedByCircle) {
        pdf.setFontSize(14);
        pdf.text("Circles Report", pageWidth / 2, yPosition, {
          align: "center",
        });
        yPosition += 10;
        // Add legend circles below "Circles Report" heading, left-aligned
        const legendStartXCircle = 15; // keep as 15

        // ✅ Total (font size 12)
        pdf.setFontSize(12);
        pdf.setTextColor(0, 0, 0);
        pdf.text(
          `Total: ${usersArray.length} | `,
          legendStartXCircle - 2,
          yPosition + 1
        );

        // ✅ Offline
        pdf.setFillColor(183, 28, 28); // #ff4d4d
        pdf.circle(legendStartXCircle + 30, yPosition, 4, "F");

        // count → smaller font (10)
        pdf.setFontSize(10);
        pdf.setTextColor(255, 255, 255);
        pdf.text(
          offlineUsers.toString(),
          legendStartXCircle + 30,
          yPosition + 1,
          { align: "center" }
        );

        // label → normal font (12)
        pdf.setFontSize(12);
        pdf.setTextColor(0, 0, 0);
        pdf.text("Offline", legendStartXCircle + 38, yPosition + 1);

        // ✅ Online
        pdf.setFillColor(76, 175, 80); // #4caf50
        pdf.circle(legendStartXCircle + 60, yPosition, 4, "F");

        // count → smaller font (10)
        pdf.setFontSize(10);
        pdf.setTextColor(255, 255, 255);
        pdf.text(
          onlineUsers.toString(),
          legendStartXCircle + 60,
          yPosition + 1,
          { align: "center" }
        );

        // label → normal font (12)
        pdf.setFontSize(12);
        pdf.setTextColor(0, 0, 0);
        pdf.text("Online", legendStartXCircle + 68, yPosition + 1);

        // ✅ Inactive
        pdf.setFillColor(117, 117, 117); // #757575
        pdf.circle(legendStartXCircle + 90, yPosition, 4, "F");

        // count → smaller font (10)
        pdf.setFontSize(10);
        pdf.setTextColor(255, 255, 255);
        pdf.text(
          inactiveUsers.toString(),
          legendStartXCircle + 90,
          yPosition + 1,
          { align: "center" }
        );

        // label → normal font (12)
        pdf.setFontSize(12);
        pdf.setTextColor(0, 0, 0);
        pdf.text("In Active", legendStartXCircle + 98, yPosition + 1);

        yPosition += 15; // Space after legend
        Object.entries(groupedByCircle).forEach(([circleCode, users]) => {
          pdf.setFontSize(16);
          pdf.setTextColor(0, 0, 0);
          const circleText = `Circle ${circleCode} - Circle ${
            users[0]?.circleName || "Unknown"
          }`;
          pdf.text(circleText, 15, yPosition);
          yPosition += 10;
          // Grid layout for users with 9 per row
          for (let i = 0; i < users.length; i += 9) {
            if (yPosition > pageHeight - 50) {
              pdf.addPage();
              yPosition = 20;
            }
            const rowUsers = users.slice(i, i + 9);
            rowUsers.forEach((user, index) => {
              const xPosition = 15 + index * 28; // Adjusted spacing for 9 rectangles
              pdf.setFontSize(9);
              pdf.setFillColor(
                user.isLogged_In ? 76 : 183,
                user.isLogged_In ? 175 : 28,
                user.isLogged_In ? 80 : 28
              );
              pdf.setTextColor(255, 255, 255); // White text for subdivision code
              pdf.rect(xPosition, yPosition, 20, 10.5, "F"); // Rectangle: 20mm wide, 10.5mm high
              // Add subdivision code at center of rectangle
              pdf.text(
                `${user.subDivisionCode || "N/A"}`,
                xPosition + 10,
                yPosition + 6.5,
                { align: "center", maxWidth: 18 }
              );
              // Add subdivision name directly below rectangle
              pdf.setTextColor(0, 0, 0); // Black text for subdivision name
              pdf.text(
                `Subdivision ${user.subDivisionName || "N/A"}`,
                xPosition + 2,
                yPosition + 15.5,
                { maxWidth: 18 }
              );
            });
            yPosition += 20.5; // Adjusted space for smaller rectangle and subdivision name
          }
          yPosition += 10;
        });
      } else if (groupedByHierarchy) {
        pdf.setFontSize(14);
        pdf.text("Circles Report", pageWidth / 2, yPosition, {
          align: "center",
        });
        yPosition += 10;

        // Add legend
        const legendStartXCircle = 15;
        pdf.setFontSize(12);
        pdf.setTextColor(0, 0, 0);
        pdf.text(
          `Total: ${usersArray.length} | `,
          legendStartXCircle - 2,
          yPosition + 1
        );

        // 🔴 Offline
        pdf.setFillColor(183, 28, 28);
        pdf.circle(legendStartXCircle + 30, yPosition, 4, "F");
        pdf.setFontSize(10);
        pdf.setTextColor(255, 255, 255);
        pdf.text(
          offlineUsers.toString(),
          legendStartXCircle + 30,
          yPosition + 1,
          { align: "center" }
        );
        pdf.setFontSize(12);
        pdf.setTextColor(0, 0, 0);
        pdf.text("Offline", legendStartXCircle + 38, yPosition + 1);

        // 🟢 Online
        pdf.setFillColor(76, 175, 80);
        pdf.circle(legendStartXCircle + 60, yPosition, 4, "F");
        pdf.setFontSize(10);
        pdf.setTextColor(255, 255, 255);
        pdf.text(
          onlineUsers.toString(),
          legendStartXCircle + 60,
          yPosition + 1,
          { align: "center" }
        );
        pdf.setFontSize(12);
        pdf.setTextColor(0, 0, 0);
        pdf.text("Online", legendStartXCircle + 68, yPosition + 1);

        // ⚪ Inactive
        pdf.setFillColor(117, 117, 117);
        pdf.circle(legendStartXCircle + 90, yPosition, 4, "F");
        pdf.setFontSize(10);
        pdf.setTextColor(255, 255, 255);
        pdf.text(
          inactiveUsers.toString(),
          legendStartXCircle + 90,
          yPosition + 1,
          { align: "center" }
        );
        pdf.setFontSize(12);
        pdf.setTextColor(0, 0, 0);
        pdf.text("In Active", legendStartXCircle + 98, yPosition + 1);

        yPosition += 15;

        Object.entries(groupedByHierarchy).forEach(
          ([circleCode, circleData]) => {
            if (yPosition > pageHeight - 50) {
              pdf.addPage();
              yPosition = 20;
            }
            pdf.setFontSize(14);
            pdf.setTextColor(0, 0, 0);

            const circleOfflineCount = Object.values(
              circleData.divisions
            ).reduce(
              (acc, div) =>
                acc +
                Object.values(div.subDivisions).reduce(
                  (subAcc, subDiv) =>
                    subAcc + subDiv.users.filter((u) => !u.isLogged_In).length,
                  0
                ),
              0
            );
            const circleOnlineCount = Object.values(
              circleData.divisions
            ).reduce(
              (acc, div) =>
                acc +
                Object.values(div.subDivisions).reduce(
                  (subAcc, subDiv) =>
                    subAcc + subDiv.users.filter((u) => u.isLogged_In).length,
                  0
                ),
              0
            );

            pdf.text(`CIRCLE ${circleData.circleName}`, 15, yPosition);

            // 🔴 Offline Circle + Count
            pdf.setFillColor(183, 28, 28);
            pdf.circle(
              15 +
                pdf.getStringUnitWidth(`CIRCLE ${circleData.circleName}`) * 2 +
                67,
              yPosition - 3,
              4,
              "F"
            );
            pdf.setFontSize(10);
            pdf.setTextColor(255, 255, 255);
            pdf.text(
              circleOfflineCount.toString(),
              15 +
                pdf.getStringUnitWidth(`CIRCLE ${circleData.circleName}`) * 2 +
                67,
              yPosition - 2,
              { align: "center" }
            );

            // 🟢 Online Circle + Count
            pdf.setFillColor(76, 175, 80);
            pdf.circle(
              15 +
                pdf.getStringUnitWidth(`CIRCLE ${circleData.circleName}`) * 2 +
                57,
              yPosition - 3,
              4,
              "F"
            );
            pdf.text(
              circleOnlineCount.toString(),
              15 +
                pdf.getStringUnitWidth(`CIRCLE ${circleData.circleName}`) * 2 +
                57,
              yPosition - 2,
              { align: "center" }
            );

            pdf.setTextColor(0, 0, 0);
            yPosition += 10;

            Object.entries(circleData.divisions).forEach(
              ([divisionCode, divisionData]) => {
                if (yPosition > pageHeight - 50) {
                  pdf.addPage();
                  yPosition = 20;
                  pdf.setFontSize(14);
                  pdf.text(`CIRCLE ${circleData.circleName}`, 15, yPosition);
                  yPosition += 10;
                }

                const divOfflineCount = Object.values(
                  divisionData.subDivisions
                ).reduce(
                  (acc, subDiv) =>
                    acc + subDiv.users.filter((u) => !u.isLogged_In).length,
                  0
                );
                const divOnlineCount = Object.values(
                  divisionData.subDivisions
                ).reduce(
                  (acc, subDiv) =>
                    acc + subDiv.users.filter((u) => u.isLogged_In).length,
                  0
                );

                // ✅ Division with bullet
                pdf.setFontSize(12);
                pdf.setTextColor(0, 0, 0);
                pdf.text(
                  `• DIVISION ${divisionData.divisionName}`,
                  15 + 4,
                  yPosition
                );

                // ✅ Offline circle
                pdf.setFillColor(183, 28, 28);
                pdf.circle(
                  15 +
                    4 +
                    pdf.getStringUnitWidth(
                      `• DIVISION ${divisionData.divisionName}`
                    ) *
                      2 +
                    60,
                  yPosition - 3,
                  4,
                  "F"
                );
                pdf.setFontSize(10);
                pdf.setTextColor(255, 255, 255);
                pdf.text(
                  divOfflineCount.toString(),
                  15 +
                    4 +
                    pdf.getStringUnitWidth(
                      `• DIVISION ${divisionData.divisionName}`
                    ) *
                      2 +
                    60,
                  yPosition - 2,
                  { align: "center" }
                );

                // ✅ Online circle
                pdf.setFillColor(76, 175, 80);
                pdf.circle(
                  15 +
                    4 +
                    pdf.getStringUnitWidth(
                      `• DIVISION ${divisionData.divisionName}`
                    ) *
                      2 +
                    50,
                  yPosition - 3,
                  4,
                  "F"
                );
                pdf.text(
                  divOnlineCount.toString(),
                  15 +
                    4 +
                    pdf.getStringUnitWidth(
                      `• DIVISION ${divisionData.divisionName}`
                    ) *
                      2 +
                    50,
                  yPosition - 2,
                  { align: "center" }
                );

                pdf.setFontSize(12);
                pdf.setTextColor(0, 0, 0);
                yPosition += 10;

                Object.entries(divisionData.subDivisions).forEach(
                  ([subDivisionCode, subDivisionData]) => {
                    if (yPosition > pageHeight - 50) {
                      pdf.addPage();
                      yPosition = 20;
                      pdf.setFontSize(14);
                      pdf.text(
                        `CIRCLE ${circleData.circleName}`,
                        15,
                        yPosition
                      );
                      yPosition += 10;
                      pdf.setFontSize(12);
                      pdf.text(
                        `• DIVISION ${divisionData.divisionName}`,
                        15 + 4,
                        yPosition
                      );
                      yPosition += 10;
                    }

                    // ✅ Subdivision with bullet
                    pdf.setFontSize(10);
                    pdf.setTextColor(0, 0, 0);
                    pdf.text(
                      `• SUBDIVISION ${subDivisionData.subDivisionName}`,
                      15 + 8,
                      yPosition
                    );
                    yPosition += 10;

                    for (let i = 0; i < subDivisionData.users.length; i += 9) {
                      if (yPosition > pageHeight - 50) {
                        pdf.addPage();
                        yPosition = 20;
                        pdf.setFontSize(14);
                        pdf.text(
                          `CIRCLE ${circleData.circleName}`,
                          15,
                          yPosition
                        );
                        yPosition += 10;
                        pdf.setFontSize(12);
                        pdf.text(
                          `• DIVISION ${divisionData.divisionName}`,
                          15 + 4,
                          yPosition
                        );
                        yPosition += 10;
                        pdf.setFontSize(10);
                        pdf.text(
                          `• SUBDIVISION ${subDivisionData.subDivisionName} (${subDivisionCode})`,
                          15 + 8,
                          yPosition
                        );
                        yPosition += 10;
                      }

                      const rowUsers = subDivisionData.users.slice(i, i + 9);
                      rowUsers.forEach((user, index) => {
                        const xPosition = 15 + index * 28;
                        pdf.setFontSize(9);
                        pdf.setFillColor(
                          user.isLogged_In ? 76 : 183,
                          user.isLogged_In ? 175 : 28,
                          user.isLogged_In ? 80 : 28
                        );
                        pdf.setTextColor(255, 255, 255);
                        pdf.rect(xPosition, yPosition, 20, 10.5, "F");
                        pdf.text(
                          `${user.subDivisionCode || "N/A"}`,
                          xPosition + 10,
                          yPosition + 6.5,
                          { align: "center", maxWidth: 18 }
                        );
                        pdf.setTextColor(0, 0, 0);
                        pdf.text(
                          `${user.subDivisionName || "N/A"}`,
                          xPosition + 2,
                          yPosition + 15.5,
                          { maxWidth: 18 }
                        );
                      });
                      yPosition += 20.5;
                    }
                    yPosition += 10;
                  }
                );
              }
            );
          }
        );
      }

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.text(`Page ${i} of ${totalPages}`, pageWidth - 45, pageHeight - 10);
      }
      // Save or download the PDF
      if (print) {
        pdf.save(
          `${desginationName}-${offName}-${dateToPrint}-Logged-In-users-Report.pdf`
        );
      } else {
        resolve(pdf);
      }
    });
  };

  // useEffect(() => {
  //   if (code == 10) {
  //     setSelectedCompanyCode('15');
  //     setOfficeCode('15');
  //   } else {
  //     setSelectedCompanyCode(code.slice(0, 2));
  //     setOfficeCode(code.slice(0, 2));
  //   }
  // }, [code]);

  // useEffect(() => {
  //   if (code == 10) {
  //     const callAllCompanies = async () => {
  //       setViewBackdrop(true);
  //       try {
  //         let companiesList = await allCompaniesAPI(token, cfpBaseUrl);
  //         if (companiesList) {
  //           companiesList = companiesList.filter((item) => item.companyCode != 1 && item.companyCode != 0);
  //           let cpList = companiesList.map((item) => ({
  //             code: item.companyCode,
  //             name: item.companyName,
  //           }));
  //           setCompanyList(cpList);
  //         } else {
  //           setCompanyList([]);
  //         }
  //       } catch (error) {
  //         console.error('Error fetching companies:', error);
  //         setCompanyList([]);
  //       } finally {
  //         setViewBackdrop(false);
  //       }
  //     };
  //     callAllCompanies();
  //   }
  // }, [code, token, cfpBaseUrl]);

  // useEffect(() => {
  //   if (code == 10 && selectedCompanyCode) {
  //     const fetchSubDivisions = async () => {
  //       setViewBackdrop(true);
  //       const myHeaders = new Headers();
  //       myHeaders.append('Authorization', token);
  //       const formdata = new FormData();
  //       formdata.append('companyCode', selectedCompanyCode);
  //       const requestOptions = {
  //         method: 'POST',
  //         headers: myHeaders,
  //         body: formdata,
  //         redirect: 'follow',
  //       };
  //       try {
  //         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
  //         if (response.ok) {
  //           const result = await response.json();
  //           if (result.status === '200') {
  //             setSubDivisions(result.message || []);
  //             const circles = (result.message || []).reduce((acc, curr) => {
  //               if (!acc.some(item => item.circleCode === curr.circleCode)) {
  //                 acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
  //               }
  //               return acc;
  //             }, []);
  //             setFilteredCircles(circles);
  //           } else {
  //             setSubDivisions([]);
  //             setFilteredCircles([]);
  //           }
  //         } else {
  //           setSubDivisions([]);
  //           setFilteredCircles([]);
  //         }
  //       } catch (error) {
  //         console.error('Error fetching subDivisions:', error);
  //         setSubDivisions([]);
  //         setFilteredCircles([]);
  //       } finally {
  //         setViewBackdrop(false);
  //       }
  //     };
  //     fetchSubDivisions();
  //   } else {
  //     const circles = (subDivisions || []).reduce((acc, curr) => {
  //       if (!acc.some(item => item.circleCode === curr.circleCode)) {
  //         acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
  //       }
  //       return acc;
  //     }, []);
  //     setFilteredCircles(circles);
  //   }
  // }, [code, selectedCompanyCode, token, cfpBaseUrl, subDivisions]);

  useEffect(() => {
    const getDesgination = async () => {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: "",
        redirect: "follow",
      };
      try {
        const response = await fetch(
          cfpBaseUrl + "workForce/getListOfSubDivisionDesignations",
          requestOptions
        );
        const result = await response.json();
        setViewBackdrop(false);
        if (result.message === "Data Found.") {
          setDesginationList(result.data || []);
          const filtered = (result.data || []).filter((item) => {
            if (complaintPart === "1") {
              return ["94", "95", "96", "113", "114", "1114", "1131"].includes(
                item.employeeDesignationId.toString()
              );
            } else if (complaintPart === "2") {
              return ["95", "113", "1135", "1145", "1146", "1147"].includes(
                item.employeeDesignationId.toString()
              );
            }
            return true;
          });
          setFilteredDesignationList(filtered);
          setDesginationCodeToApi(complaintPart === "1" ? "113" : "1135");
        } else {
          setDesginationList([]);
          setFilteredDesignationList([]);
        }
      } catch (error) {
        console.error("Error fetching designations:", error);
        setDesginationList([]);
        setFilteredDesignationList([]);
        setViewBackdrop(false);
      }
    };
    getDesgination();
  }, [token, complaintPart]);

  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error("Error fetching subDivisions:", result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching subDivisions:", error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 4));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 5) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 5));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        console.log("1 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        console.log("2 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        console.log("3 wala if");
        setCircleCode(offCode.slice(0, 3));
        console.log(offCode.slice(0, 3), "djlsahjdhalhdalhlkd");
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        console.log("4 wala if");
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const handlePart = (e) => {
    const selectedPart = e.target.value;
    setComplaintPart(selectedPart);
    if (selectedPart === "1") {
      const filtered = desginationList.filter(
        (item) => item.employeeDesignationId.toString() === "1135"
      );
      setFilteredDesignationList(filtered);
      setDesginationCodeToApi("1135");
    } else {
      setFilteredDesignationList(desginationList);
      setDesginationCodeToApi(
        desginationList[0]?.employeeDesignationId || "1135"
      );
    }
  };

  const handleChangeDesgination = (e) => {
    console.log(e.target.value, "e.target.value");
    const selectedId = e.target.value;

    setDesginationCodeToApi(selectedId);
    const selectedObj = desginationList.find(
      (item) => item.employeeDesignationId.toString() === selectedId
    );
    if (selectedObj) {
      setDesginationName(selectedObj.employeeDesignationName); // <-- store name only
    }
  };

  const handleSourceWise = (e) => {
    setSourceWise(e.target.value);
  };

  const handleShiftWise = (e) => {
    setShiftWise(e.target.value);
  };

  const getLoggedInUsers = async (
    sourceWise,
    offCode,
    desginationCodeToApi,
    complaintPart,
    shiftWise
  ) => {
    setViewBackdrop(true);
    // const effectiveOfficeCode = selectedSubDivision || selectedDivision || circleCode || selectedCompanyCode || code.slice(0, 2);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      officeCode: offCode,
      roleId: desginationCodeToApi || "1135",
      isLoggedInFromMobile: sourceWise,
      shiftId: shiftWise,
      roleTypeId: complaintPart,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    setViewBackdrop(true);
    try {
      const response = await fetch(
        cfpBaseUrl + "workForce/getUserLoggedStatus",
        requestOptions
      );
      const result = await response.json();
      if (result.status == "200") {
        setNoDataFound(false);
        setUsersArray(result.data || []);
        let offline = (result.data || []).filter(
          (item) => !item.isLogged_In && item.isAccountExists == "1"
        ).length;
        setOfflineUsers(offline);
        let online = (result.data || []).filter(
          (item) => item.isLogged_In == true && item.isAccountExists == "1"
        ).length;
        setOnlineUsers(online);
        let inactive = (result.data || []).filter(
          (item) => item.isAccountExists == "0"
        ).length;
        setInactiveUsers(inactive);
        setIsDesignation1135(desginationCodeToApi === "1135");
      } else if (result.status == "400") {
        setNoDataFound(true);
        setUsersArray([]);
        setOfflineUsers(0);
        setOnlineUsers(0);
        setInactiveUsers(0);
        setIsDesignation1135(false);
      }
    } catch (error) {
      console.error(error);
      setNoDataFound(true);
      setUsersArray([]);
      setOfflineUsers(0);
      setOnlineUsers(0);
      setInactiveUsers(0);
      setIsDesignation1135(false);
    } finally {
      setViewBackdrop(false);
    }
  };

  useEffect(() => {
    console.log("offcode", offCode);
    getLoggedInUsers(
      sourceWise,
      offCode,
      desginationCodeToApi,
      complaintPart,
      shiftWise
    );
  }, []);

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (code) {
        setOfficeCode(code == 10 ? 15 : code);
        let offName = getName(
          code == 10 ? "15" : code.toString(),
          subDivisions
        );
        setFilteredCircles(
          (subDivisions || []).reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, [])
        );
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 2) {
        if (code) {
          setOfficeCode(code.toString().slice(0, 2));
          setFilteredCircles(
            (subDivisions || []).reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, [])
          );
        }
      } else if (cfcLevelId == 3) {
        if (code) {
          setOfficeCode(code.toString().slice(0, 3));
          setCircleCode(code.slice(0, 3));
          setFilteredDivisions(
            (subDivisions || [])
              .filter((item) => item.circleCode == code.slice(0, 3))
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, [])
          );
        }
      } else if (cfcLevelId == 4 || cfcLevelId == 5) {
        if (code) {
          setOfficeCode(code.toString().slice(0, 4));
          setSelectedDivision(code.slice(0, 4));
          setFilteredSubDivisions(
            (subDivisions || [])
              .filter((item) => item.divisionCode == code.slice(0, 4))
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, [])
          );
        }
      }
    }
  }, [code, roleTypeName, cfcLevelId, subDivisions]);

  useEffect(() => {
    window.localStorage.setItem("subDivisions", JSON.stringify(subDivisions));
  }, [subDivisions]);

  const groupedByHierarchy = (usersArray || []).reduce((acc, user) => {
    const circleCode = user.circleCode || "Unknown Circle";
    const divisionCode = user.divisionCode || "Unknown Division";
    const subDivisionCode = user.subDivisionCode || "Unknown SubDivision";

    if (!acc[circleCode]) {
      acc[circleCode] = {
        circleName: user.circleName || "Unknown Circle",
        divisions: {},
      };
    }

    if (!acc[circleCode].divisions[divisionCode]) {
      acc[circleCode].divisions[divisionCode] = {
        divisionName: user.divisionName || "Unknown Division",
        subDivisions: {},
      };
    }

    if (
      !acc[circleCode].divisions[divisionCode].subDivisions[subDivisionCode]
    ) {
      acc[circleCode].divisions[divisionCode].subDivisions[subDivisionCode] = {
        subDivisionName: user.subDivisionName || "Unknown SubDivision",
        users: [],
      };
    }

    acc[circleCode].divisions[divisionCode].subDivisions[
      subDivisionCode
    ].users.push(user);
    return acc;
  }, {});

  const groupedByCircle = (usersArray || []).reduce((acc, user) => {
    const circleCode = user.circleCode || "Unknown Circle";
    if (!acc[circleCode]) {
      acc[circleCode] = [];
    }
    acc[circleCode].push(user);
    return acc;
  }, {});

  const currentFilters = {
    sourceWise,
    officeCode,
    desginationCodeToApi,
    complaintPart,
    shiftWise,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [sourceWise, officeCode, desginationCodeToApi, complaintPart, shiftWise]);

  const handleGoClick = () => {
    getLoggedInUsers(
      sourceWise,
      officeCode,
      desginationCodeToApi,
      complaintPart,
      shiftWise
    );

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  return (
    <>
      <Box className="form-box">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            className="legends"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "15px",
              alignItems: "center",
            }}
          >
            <div
              className="legend-div"
              style={{ borderRight: "2px solid black", paddingRight: "20px" }}
            >
              <h3>Total: {usersArray.length}</h3>
            </div>
            <div className="legend-div">
              <div
                className="circle offline"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  backgroundColor: "#ff4d4d",
                  marginRight: "5px",
                }}
              >
                <span
                  style={{
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {offlineUsers}
                </span>
              </div>
              Offline
            </div>
            <div className="legend-div">
              <div
                className="circle online"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  backgroundColor: "#4caf50",
                  marginRight: "5px",
                }}
              >
                <span
                  style={{
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {onlineUsers}
                </span>
              </div>
              Online
            </div>
            <div className="legend-div">
              <div
                className="circle inactive"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  backgroundColor: "#757575",
                  marginRight: "5px",
                }}
              >
                <span
                  style={{
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {inactiveUsers}
                </span>
              </div>
              In Active
            </div>
            {code == 10 && (
              <div className="field-container">
                <Typography className="field-label">Company</Typography>
                <select
                  className="dropdown-field"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                    padding: "5px 10px",
                  }}
                  value={selectedCompanyCode}
                  onChange={(e) => {
                    handleChangeCompany(e);
                  }}
                >
                  <option value="10">Select Company</option>
                  <option value="11">LESCO</option>
                  <option value="12">GEPCO</option>
                  <option value="13">FESCO</option>
                  <option value="14">IESCO</option>
                  <option value="15">MEPCO</option>
                  <option value="26">PESCO</option>
                  <option value="27">HAZECO</option>
                  <option value="37">HESCO</option>
                  <option value="38">SEPCO</option>
                  <option value="48">QESCO</option>
                  <option value="59">TESCO</option>
                </select>
              </div>
            )}

            {hierarchy <= 2 && (
              <div className="field-container">
                <Typography className="field-label">Circle</Typography>
                <select
                  className="dropdown-field"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                    padding: "5px 10px",
                  }}
                  value={circleCode || ""}
                  onChange={(e) => {
                    handleCircleChange(e);
                  }}
                >
                  <option value="">All Circle</option>
                  {filteredCircles.map((circle) => (
                    <option key={circle.circleCode} value={circle.circleCode}>
                      {circle.circleName}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {hierarchy <= 3 && (
              <div className="field-container">
                <Typography className="field-label">Division</Typography>
                <select
                  className="dropdown-field"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                    padding: "5px 10px",
                  }}
                  value={selectedDivision || ""}
                  onChange={(e) => {
                    handleDivisionChange(e);
                  }}
                  disabled={!circleCode}
                >
                  <option value="">All Division</option>
                  {filteredDivisions.map((division) => (
                    <option
                      key={division.divisionCode}
                      value={division.divisionCode}
                    >
                      {division.divisionName}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {hierarchy <= 4 && (
              <div className="field-container">
                <Typography className="field-label">Sub-Division</Typography>
                <select
                  className="dropdown-field"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                    padding: "5px 10px",
                  }}
                  value={selectedSubDivision || ""}
                  onChange={(e) => {
                    handleSubDivisionChange(e);
                  }}
                  disabled={!selectedDivision}
                >
                  <option value="">All Sub-Division</option>
                  {filteredSubDivisions.map((subDivision) => (
                    <option
                      key={subDivision.subDivisionCode}
                      value={subDivision.subDivisionCode}
                    >
                      {subDivision.subDivisionName}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="field-container">
              <Typography className="field-label">Part</Typography>
              <select
                className="dropdown-field"
                style={{
                  backgroundColor: "white",
                  border: "1px solid lightgray",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  width: "150px",
                }}
                value={complaintPart}
                onChange={(e) => {
                  handlePart(e);
                }}
              >
                <option value="1">Commercial</option>
                <option value="2">Technical</option>
              </select>
            </div>
            <div className="field-container">
              <Typography className="field-label">Designation</Typography>
              <select
                className="dropdown-field"
                style={{
                  backgroundColor: "white",
                  border: "1px solid lightgray",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  width: "150px",
                }}
                value={desginationCodeToApi}
                onChange={(e) => {
                  handleChangeDesgination(e);
                }}
                disabled={!filteredDesignationList.length}
              >
                {filteredDesignationList.map((item, index) => (
                  <option key={index} value={item.employeeDesignationId}>
                    {item.employeeDesignationName}
                  </option>
                ))}
              </select>
            </div>
            <div className="field-container">
              <Typography className="field-label">Source</Typography>
              <select
                className="dropdown-field"
                style={{
                  backgroundColor: "white",
                  border: "1px solid lightgray",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  width: "150px",
                }}
                value={sourceWise}
                onChange={(e) => {
                  handleSourceWise(e);
                }}
              >
                <option value="2">Both</option>
                <option value="0">Web</option>
                <option value="1">Mobile</option>
              </select>
            </div>
            <div className="field-container">
              <Typography className="field-label">Shift</Typography>
              <select
                className="dropdown-field"
                style={{
                  backgroundColor: "white",
                  border: "1px solid lightgray",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  width: "150px",
                }}
                value={shiftWise}
                onChange={(e) => {
                  handleShiftWise(e);
                }}
              >
                <option value="1">Morning</option>
                <option value="2">Evening</option>
                <option value="3">Night</option>
                <option value="4">Feeder Wise</option>
              </select>
            </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginTop: "10px" }}
                  onClick={handleGoClick}
                  disabled={isGoDisabled || viewBackdrop}
                >
                  Go
                </Button>
                {/* <Button
                  variant="outlined"
                  color="secondary"
                  style={{ marginTop: '10px' }}
                  onClick={downloadPDF}
                  disabled={usersArray.length === 0}
                >
                  Download PDF
                </Button> */}
              </div>
             <div
                    onClick={() => {
                      if (noDataFound) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>
          </div>
        </div>
        {noDataFound ? (
          <div
            style={{
              padding: "20px",
              textAlign: "center",
              fontWeight: "bold",
              color: "red",
            }}
          >
            No Data Found.
          </div>
        ) : isDesignation1135 ? (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {Object.entries(groupedByCircle).map(([circleCode, users]) => (
              <div key={circleCode}>
                <h3
                  style={{
                    margin: "10px 0",
                    fontSize: "25px",
                    fontWeight: "bold",
                  }}
                >
                  Circle {circleCode} - {users[0]?.circleName || "Unknown"}
                </h3>
                <div
                  style={{
                    display: "grid",
                    gap: "5px",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(100px, 1fr))",
                  }}
                >
                  {users.map((user, index) => (
                    <div key={user.userid}>
                      <Block item={user} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {Object.entries(groupedByHierarchy).map(
              ([circleCode, circleData]) => (
                <div key={circleCode}>
                  <h3
                    style={{
                      margin: "10px 0",
                      fontSize: "25px",
                      fontWeight: "bold",
                    }}
                  >
                    {circleData.circleName}
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        background: "linear-gradient(#000, #b71c1c)",
                        marginRight: "5px",
                        marginLeft: 20,
                      }}
                    >
                      <span
                        style={{
                          color: "white",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        {Object.values(circleData.divisions).reduce(
                          (acc, div) =>
                            acc +
                            Object.values(div.subDivisions).reduce(
                              (subAcc, subDiv) =>
                                subAcc +
                                subDiv.users.filter((u) => !u.isLogged_In)
                                  .length,
                              0
                            ),
                          0
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        backgroundColor: "#4caf50",
                        marginRight: "5px",
                      }}
                    >
                      <span
                        style={{
                          color: "white",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        {Object.values(circleData.divisions).reduce(
                          (acc, div) =>
                            acc +
                            Object.values(div.subDivisions).reduce(
                              (subAcc, subDiv) =>
                                subAcc +
                                subDiv.users.filter((u) => u.isLogged_In)
                                  .length,
                              0
                            ),
                          0
                        )}
                      </span>
                    </div>
                  </h3>
                  {Object.entries(circleData.divisions).map(
                    ([divisionCode, divisionData]) => (
                      <div
                        key={divisionCode}
                        style={{ marginLeft: "20px", marginBottom: "20px" }}
                      >
                        <h4
                          style={{
                            margin: "10px 0",
                            fontSize: "20px",
                            fontWeight: "bold",
                          }}
                        >
                          {divisionData.divisionName}
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "25px",
                              height: "25px",
                              borderRadius: "50%",
                              background: "linear-gradient(#000, #b71c1c)",
                              marginRight: "5px",
                              marginLeft: 15,
                            }}
                          >
                            <span
                              style={{
                                color: "white",
                                fontSize: "11px",
                                fontWeight: "bold",
                              }}
                            >
                              {Object.values(divisionData.subDivisions).reduce(
                                (acc, subDiv) =>
                                  acc +
                                  subDiv.users.filter((u) => !u.isLogged_In)
                                    .length,
                                0
                              )}
                            </span>
                          </div>
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "25px",
                              height: "25px",
                              borderRadius: "50%",
                              backgroundColor: "#4caf50",
                              marginRight: "5px",
                            }}
                          >
                            <span
                              style={{
                                color: "white",
                                fontSize: "11px",
                                fontWeight: "bold",
                              }}
                            >
                              {Object.values(divisionData.subDivisions).reduce(
                                (acc, subDiv) =>
                                  acc +
                                  subDiv.users.filter((u) => u.isLogged_In)
                                    .length,
                                0
                              )}
                            </span>
                          </div>
                        </h4>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns:
                              "repeat(auto-fit, minmax(250px, 1fr))",
                            gap: "20px",
                            padding: "10px",
                            border: "1px solid #e0e0e0",
                            borderRadius: "5px",
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          {Object.entries(divisionData.subDivisions).map(
                            ([subDivisionCode, subDivisionData]) => (
                              <div
                                key={subDivisionCode}
                                style={{
                                  padding: "10px",
                                  border: "1px solid #d3d3d3",
                                  borderRadius: "5px",
                                  backgroundColor: "#fff",
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                }}
                              >
                                <h5
                                  style={{
                                    margin: "10px 0",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {subDivisionData.subDivisionName}
                                </h5>
                                <div
                                  style={{
                                    display: "grid",
                                    gap: "5px",
                                    gridTemplateColumns:
                                      "repeat(auto-fill, minmax(100px, 1fr))",
                                  }}
                                >
                                  {subDivisionData.users.map((user) => (
                                    <div key={user.userid}>
                                      <Block item={user} />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )
                  )}
                </div>
              )
            )}
          </div>
        )}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
          open={viewBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </>
  );
};

export default LoggedInUsers;
